export const BytesStringToKb = (string: string) => {
  return Math.round(Number(parseInt(string) / 1024)); // will work up to 9 pedabytes, was using bigint but that doesnt work on ios 13
};
